import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import pad from 'pad';
import {
  faEdit,
  faTrashAlt,
  faCheck,
  faTimes,
  faFlag,
} from '@fortawesome/free-solid-svg-icons';
import {
  DropdownButton,
  Dropdown
} from 'react-bootstrap';
import PrinterFullEntrega from './imprimir/full.printer';
import moment from 'moment';

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    }
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};

const colummnsComplete = () => {
  return [
    {
      name: 'Guia',
      selector: 'id',
      sortable: true,
      cell: (row) => (
        <div>
          {pad(5, row.id, '0')}
        </div>
      )
    },
    {
      name: 'Descripción',
      selector: 'description',
      sortable: true,
      cell: (row) => (
        <div>
         {row.description}
        </div>
      )
    },
    {
      name: 'Tipo',
      selector: row => row.rel_tipos.description,
      sortable: true,
      width: '10%',
      cell: (row) => (
        <div>
          {row.rel_tipos.description}
        </div>
      )
    },
    {
      name: 'Salida',
      selector: 'date_aperture',
      sortable: true,
      cell: (row) => (
        <div>
          {moment(row.date_aperture).format('DD/MM/YYYY')}
        </div>
      )
    },
    {
      name: 'Completada',
      selector: 'date_close',
      sortable: true,
      cell: (row) => (
        <div>
          {moment(row.date_close).format('DD/MM/YYYY')}
        </div>
      )
    },
    {
      name: 'Guias Nº',
      selector: 'cantidad_guias',
      sortable: true,
      right: true,
      cell: (row) => (
        <div>
          {row.cantidad_guias}
        </div>
      )
    },
  ];
}

const colummnsWithFunc = (callbackEdit, callbackDel, permisse, callbackClose, showPrefixGuide) => {
  return [
    {
      name: 'Guia',
      selector: 'id',
      sortable: true,
      width: '10%',
      cell: (row) => (
        <div>
          {pad(5, row.id, '0')}
        </div>
      )
    },
    {
      name: 'Descripción',
      selector: 'description',
      sortable: true,
      width: '25%',
      cell: (row) => (
        <div>
         {row.description}
        </div>
      )
    },
    {
      name: 'Tipo',
      selector: row => row.rel_tipos.description,
      sortable: true,
      width: '10%',
      cell: (row) => (
        <div>
          {row.rel_tipos.description}
        </div>
      )
    },
    {
      name: 'Salida',
      selector: 'date_aperture',
      sortable: true,
      width: '10%',
      cell: (row) => (
        <div>
          {moment(row.date_aperture).format('DD/MM/YYYY')}
        </div>
      )
    },
    {
      name: 'Guias Nº',
      selector: 'cantidad_guias',
      sortable: true,
      width: '10%',
      right: true,
      cell: (row) => (
        <div>
          {row.cantidad_guias}
        </div>
      )
    },
    {
      name: 'Notificaciones',
      selector: 'notification',
      sortable: true,
      center: true,
      width: '10%',
      cell: (row) => (
        <div>
          {row.notification ?  <FontAwesomeIcon icon={faCheck} /> :  <FontAwesomeIcon icon={faTimes} />}
        </div>
      )
    },
    {
      name: 'Estado',
      selector: 'status',
      sortable: true,
      width: '10%',
      cell: (row) => (
        row.status ? 'ACTIVO' : 'CERRADO'
      )
    },
    {
      name: 'Acciones',
      right: true,
      cell: (row) => (
        <div className="mt-2 mb-2">
        <DropdownButton  size="sm" variant="secondary" title="Opciones">
          <Dropdown.Item disabled={parseInt(row.cantidad_guias) ? false : true} onClick={() => callbackClose(row)}> 
            <FontAwesomeIcon icon={faFlag} /> Cerrar master</Dropdown.Item>
          <Dropdown.Item onClick={() => callbackEdit(row)}> <FontAwesomeIcon icon={faEdit} /> Editar </Dropdown.Item>
          {permisse === 1 &&
            <Dropdown.Item onClick={() => callbackDel(row)}> <FontAwesomeIcon icon={faTrashAlt} /> Eliminar </Dropdown.Item>
          }
          <PrinterFullEntrega 
            masterId={row.id} 
            campo="guia_master"
            showPrefixGuide={showPrefixGuide}
          />
        </DropdownButton>
        </div>
      )
    },
  ];
}  

const columnEstadosMasterOriginal = [
    {
      name: 'Estado',
      selector: 'descripcion',
      sortable: true,
    },
    {
      name: 'Fecha',
      selector: 'createdAt',
      sortable: true,
      cell: (row) => (
      <div>{moment(row.createdAt).format('DD/MM/YYYY H:mm')}</div>
      )
    },  
];

const columnEstadosMaster = (prefix, showPrefixGuide) => {
  return [
    {
      name: 'Guia',
      selector: 'guia_paquete',
      sortable: true,
      cell: (row) => (
      <div>{`${showPrefixGuide ? row.master_guia.rel_tipos.prefijo : prefix}-${row.guia_paquete}`}</div>
      )
    },
    {
      name: 'Cliente',
      selector: row => row.cliente.name,
      sortable: true,
      cell: row => (
        <div className="flex-column">
        <small>{row.cliente.rut}</small>
        <div>{row.cliente.name.toUpperCase()}</div>
        </div>
      )
    },
    {
      name: 'Destino',
      selector: row => row.estado_guia.estado,
      sortable: true,
    },
    {
      name: 'Estado',
      selector: 'guia_finalizada',
      sortable: true,
      cell: (row) => (
        <div>
          {
          row.anulado === 1 && !row.guia_finalizada ? <span className="badge badge-danger">ANULADO</span>
          :!row.anulado && row.guia_finalizada ? <span className="badge badge-success">ENTREGADO</span>
          :!row.anulado && !row.guia_finalizada && row.guia_pendiente ? <span className="badge badge-primary">RESERVADA</span> 
          : <span className="badge badge-warning">TRANSITO</span>  
          }
       </div>
      )
    },
  ]
};

const tableMaster = {
  customStyles,
  colummnsWithFunc,
  columnEstadosMaster,
  columnEstadosMasterOriginal,
  colummnsComplete,
}

export default tableMaster;